import {
  SUPPORTED_CHAINS,
  SUPPORTED_MCC,
  SUPPORTED_MCC_NAME,
  SUPPORTED_MCC_NAME_V2,
  SUPPORTED_MCC_CODE_V2
} from "@/constant/Constant";
import {STORAGE_KEY} from "../constant/StorageConstant";
import {TRANS_TYPE} from "@/constant/Constant";
import moment from "moment";
import { UAParser } from 'ua-parser-js';
// import API from "@/constant/API";
// import axiosInstance from "./axios";

export const searchByName = (listData, searchValue) => {
  if (searchValue?.length > 0) {
    const searchResult = listData.filter((item) =>
      item.name.toLocaleLowerCase().match(searchValue.toLowerCase())
    );
    return searchResult;
  } else {
    return listData;
  }
};
export const getRoute = (pathname) => {
  const str = pathname.split("/");
  return `/${str[1]}`;
};
export const toFixedNum = (num, fixed) => {
  const fixedNum = fixed || 2;
  return Number(num).toFixed(fixedNum);
};

export const detectBrowser = () => {
  const userAgent = window.navigator.userAgent;

  let browser = "";
  if (userAgent.indexOf("Firefox") > -1) {
    browser = "Mozilla Firefox";
  } else if (userAgent.indexOf("Opera") > -1 || userAgent.indexOf("OPR") > -1) {
    browser = "Opera";
  } else if (userAgent.indexOf("Trident") > -1) {
    browser = "Microsoft Internet Explorer";
  } else if (userAgent.indexOf("Edge") > -1) {
    browser = "Microsoft Edge";
  } else if (userAgent.indexOf("Chrome") > -1) {
    browser = "Google Chrome";
  } else if (userAgent.indexOf("Safari") > -1) {
    browser = "Apple Safari";
  } else {
    browser = "unknown";
  }
  return browser;
};

export const getDefaultLang = () => {
  let lang = "en";
  const settingsStr = window.localStorage.getItem(STORAGE_KEY.SETTINGS);
  if (settingsStr) {
    try {
      const settings = JSON.parse(settingsStr);
      lang = settings?.lang ?? "en";
    } catch (err) {
    }
  } else {
    lang = window.navigator.language;
    if (lang == "zh-CN") {
      lang = "cn";
    } else if (lang == "zh-HK") {
      lang = "hk";
    } else {
      lang = "en";
    }
  }
  return lang;
};

export const getLangDisplay = (lang) => {
  if (lang === "cn") return "中文(简体)";
  else if (lang === "hk") return "中文(繁體)";
  else if (lang === "ar") return "العربية";
  else if (lang === "fr") return "Français";
  else if (lang === "ja") return "日本語";
  else if (lang === "es") return "Español";
  else if (lang === "pt") return "Português";
  else if (lang === "th") return "ภาษาไทย";
  else if (lang === "kr") return "한국인";
  else if (lang === "tr") return "Türkçe";

  // else if (lang === "ru") return "俄语";

  else return "English";
};

export const getLocationPath = () => {
  let path = window.location.pathname;
  if (path.indexOf("/") === 0) {
    return path.substring(1);
  }
};

export const isBroswerDarkMode = () => {
  return window.matchMedia("(prefers-color-scheme:dark)")?.matches || false;
};

export const objectIsEmpty = (obj = {}) => {
  return Object.keys(obj).length === 0;
};

export const ellipsisWalletAddress = (address) => {
  if (!address || address.length <= 15) {
    return address;
  }
  return `${address.substring(0, 5)}...${address.substr(-4)}`;
};

export const languageOptions = {
  en: {
    icon: "/images/flags/language/en-us.svg",
    label: "English",
  },
  cn: {
    icon: "/images/flags/language/zh.svg",
    label: "中文(简体)",
  },
  hk: {
    icon: "/images/flags/hk.svg",
    label: "中文(繁體)",
  },
  ar: {
    icon: "/images/flags/language/ar.svg",
    label: "العربية"
  },
  fr: {
    icon: "/images/flags/language/fr.svg",
    label: "Français"
  },
  ja: {
    icon: "/images/flags/language/ja.svg",
    label: "日本語"
  },
  th: {
    icon: "/images/flags/language/th.svg",
    label: "ภาษาไทย"
  },
  kr: {
    icon: "/images/flags/language/kr.svg",
    label: "한국어"
  },
  tr: {
    icon: "/images/flags/language/tr.svg",
    label: "Türkçe"
  },
  es: {
    icon: "/images/flags/language/es.svg",
    label: "Español"
  },
  pt: {
    icon: "/images/flags/language/pt.svg",
    label: "Português"
  },

  // ru: {
  //   icon: "/images/flags/language/en-us.svg",
  //   label: "Russia",
  // },

};

export const getLangOption = (lang) => {
  return languageOptions[lang] || languageOptions.en;
};

export const getSettings = () => {
  const settings = window.localStorage.getItem("settings");
  if (settings) {
    try {
      return JSON.parse(settings);
    } catch (err) {
      // ignore
    }
  }
  return null;
};

export const getNationIcon = (nation) => {
  if (!nation?.code) return "";
  return `/images/flags/${nation.code.toLowerCase()}.svg`;
};

export const getNationIconByCode2 = (code2) => {
  if (!code2) return "";
  return `/images/flags/${code2.toLowerCase()}.svg`;
};

export const getChainImg = (chainId) => {
  return `/images/chain/${chainId}.svg`;
};

export function getDefaultCountry(countryList, ipCountryCode) {
  let country = null;
  if (ipCountryCode) {
    country = countryList.find(
      (element) =>
        element.code?.toLowerCase() == ipCountryCode.toLowerCase() ||
        element.code3?.toLowerCase() == ipCountryCode.toLowerCase()
    );
    if (country) return country;
  }

  const settings = getSettings();
  const lang = settings?.lang ?? "en";
  if (lang == "zh")
    country = countryList.find(
      (element) => element.code?.toLowerCase() == "sg"
    );
  if (lang == "tw")
    country = countryList.find(
      (element) => element.code?.toLowerCase() == "hk"
    );
  if (lang == "ja")
    country = countryList.find(
      (element) => element.code?.toLowerCase() == "jp"
    );
  if (country == null) country = countryList[0];
  return country;
}

export function isSupportChain(chainId) {
  if (!chainId) return false;
  return (
    SUPPORTED_CHAINS.findIndex((chainItem) => chainItem.chainId == chainId) !== -1
  );
}

export function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function isEmptyNumber(val) {
  return !val || !Number(val);
}

export function isEmptyString(val) {
  return !val || !val.trim();
}

export function getResourceByMccName(name) {
  if (name == null) return null;
  const mccName = SUPPORTED_MCC_NAME.find((e) => {
    if (e instanceof Array) {
      let allMatch = true;
      e.forEach((item) => {
        if (name.toLowerCase().indexOf(item) == -1) {
          allMatch = false;
          return;
        }
      });
      return allMatch;
    }
    return name.toLowerCase().indexOf(e) != -1;
  });
  if (mccName == null) return null;
  if (mccName instanceof Array) {
    const fullMccName = mccName.join("_");
    return `/images/mcc/name/${fullMccName}.svg`;
  }
  return `/images/mcc/name/${mccName}.svg`;
}

export function getResourceByMcc(mcc) {
  if (mcc == null) return null;
  const mccCode = SUPPORTED_MCC.find((e) => e == mcc);
  if (mccCode == null) return null;
  return `https://rp-static-apne1.s3.ap-northeast-1.amazonaws.com/index/image/mcc/mcc_${mccCode}.svg`;
}

export function getResourceByMccV2(mccCode, mccName) {

  if (!mccCode || !mccName) return null;
  // const mccCode = SUPPORTED_MCC.find((e) => e == mcc);
  let file = SUPPORTED_MCC_NAME_V2.find((e) => {
    return e.includes(mccName);
  });

  if (file) {
    return `/images/new-mcc/name/${mccName}.svg`;
  }
  file = SUPPORTED_MCC_CODE_V2.find((e) => {
    return e.includes(mccCode);
  })
  if (!file) {

    return null;
  }
  return `/images/new-mcc/icon/${file}.svg`;
}

export function getIconByBizType(type) {
  switch (type) {
    case TRANS_TYPE.WALLET_DEPOSIT:
    case TRANS_TYPE.BINANCE_PAY_DEPOSIT:
    case TRANS_TYPE.GATE_REDEEM_CARD_DEPOSIT:
    case TRANS_TYPE.REDEEM_CARD_DEPOSIT:
      return "plus";
    case TRANS_TYPE.WALLET_WITHDRAW:
      return "reduce";
    case TRANS_TYPE.TYJ:
    case TRANS_TYPE.REBATE_WITHDRAW:
    case TRANS_TYPE.EXPIRE_TYJ:
      return "gift";
    case TRANS_TYPE.TRANSFER:
    case TRANS_TYPE.TRANSFER_INSITE:
    case TRANS_TYPE.EXCHANGE:
      return "exchange";
    case TRANS_TYPE.CARD_APPLY:
    case TRANS_TYPE.CARD_CONSUMPTION:
    case TRANS_TYPE.CARD_APPLY_REFUND:
    case TRANS_TYPE.SAAS_BILL:
      return "card";
    // case TRANS_TYPE.VIP_UPGRADE:  //这个类型应该用不到
    //   return "0xe642"; //todo

    default:
      return "usd";
  }
}

export function getDecimalPlaces(num) {
  if (num % 1 !== 0) {
    return num.toString().split(".")[1].length;
  } else {
    return 0;
  }
}

export function getDefaultBirthday() {
  const now = new Date();
  // 目前接受生日18岁以上
  now.setFullYear(new Date().getFullYear() - 18);
  return moment(now).toDate();
}

export function getRegExpByPrecision(precision) {
  return new RegExp(`^[0-9]+(\\.[0-9]{0,${precision}})?$`);
}

export function filterCountries(countries, keyword) {
  if (!countries?.length) return [];

  return countries.filter(
    (country) =>
      country?.areaCode.indexOf(keyword) !== -1 ||
      country?.code3?.indexOf(keyword?.toUpperCase()) !== -1 ||
      country?.code?.indexOf(keyword?.toUpperCase()) !== -1 ||
      country?.name?.toLowerCase().indexOf(keyword?.toLowerCase()) !== -1 ||
      country?.enName?.toLowerCase().indexOf(keyword?.toLowerCase()) !== -1
  );
}

export function mobileAndTabletCheck() {
  let check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}

export function getPrecision(num) {
  const match = num.toString().match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
  if (!match) return 0;
  // 小数点后的位数
  return Math.max(
    0,
    // Number of digits right of decimal point.
    (match[1] ? match[1].length : 0) -
    // Adjust for scientific notation.
    (match[2] ? +match[2] : 0)
  );
}

export function generateUniqueId() {
  // 生成当前时间戳
  let timestamp = Date.now().toString(36);

  // 生成4位随机数
  let randomStr = Math.random().toString(36).substr(2, 4);

  // 结合时间戳和随机数生成唯一ID
  return timestamp + randomStr;
}

/**
 * 获取url 参数
 */
export function getUrlParams(param) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get(param);
}

export function getSequenceRepeatCharactar(str, len) {
  let re = new RegExp('(\\d)\\1{' + (len - 1) + ',}', 'g');
  // let re = /(\d)\1{3,}/g;
  str += ''
  if (str.match(re)) {
    return str.match(re);
  }
  return re.test(str)
}

export function getIncreasingDecreasingV1(str) {
  let len = 3
  var isDigit = /^.*[0-9]+.*/;//数字
  var isLowerCase = /^.*[a-z]+.*/; // isLowerCase
  var isUpperCase = /^.*[A-Z]+.*/; // isUpperCase
  var regEx = /^.*[^a-zA-Z0-9]+.*/;// 特殊字符

  let numberSequence = false;
  for (let i = 0; i < str.length - (len - 1); i++) {
    if (!isDigit.test(str.substring(i, i + 1))
      || !isDigit.test(str.substring(i + 1, i + 2) + "")
      || !isDigit.test(str.substring(i + 2, i + 3) + "")
      // || !isDigit.test(str.substring(i + 3, i + 4) + "")
    ) {
      continue;
    }
    var n1 = Number(str.substring(i, i + 1));
    var n2 = Number(str.substring(i + 1, i + 2));
    var n3 = Number(str.substring(i + 2, i + 3));
    if (n1 + 1 == n2 && n2 + 1 == n3) {
      numberSequence = true;
    }
    return numberSequence
  }
}

export function getIncreasingDecreasing(str, len = 4) {
  const arr = Array.from(str);
  if (arr.length < len) {
    return false;
  }
  for (let i = 0; i < arr.length - len + 1; i++) {
    const codeArr = [];
    let same = 0;
    let order = 0;
    for (let j = 0; j < len; j++) {
      codeArr.push(str.charCodeAt(i + j));
      if (j !== 0) {
        if (codeArr[j] === codeArr[j - 1]) {
          same += 1;
        }
        if (Math.abs(codeArr[j] - codeArr[j - 1]) === 1) {
          order += 1;
        }
      }
    }
    if (same === len - 1 || order === len - 1) {
      // console.log('low', len, str);
      return false;
    }
  }
  // console.log('strong', len, str);
  return true;
}

export const generateThemeId = (savedThemes) => {
  // generate a long string of characters
  const genString = () =>
    ["", "", ""].reduce(
      (str, _) => (str += Math.random().toString(36).substring(2, 15)),
      ""
    )

  let id
  do {
    id = genString()
  } while (savedThemes.hasOwnProperty(id))

  return id
}

export const getDeviceId = () => {
  const userAgent = window.navigator.userAgent;
  return userAgent.length > 100 ? userAgent.substring(0, 80) + '...' : userAgent;
}

export const isDark = (theme) => {
  return theme.palette.mode == 'dark';
}


export const getUAInfo = () => {
  const userAgent = window.navigator.userAgent;
  const uaInfo = UAParser(userAgent);
  return {
    ...uaInfo
  }
        // N900
}
// export async function createPV(){
//   try{
//     let uvId = localStorage.getItem("uvId");
//     if(!uvId){
//       const res = await axiosInstance.post(API.CREATE_PV);
//       uvId =  res.uvId
//       localStorage.setItem("uvId",uvId)
//     }
//     return uvId;
//   }catch(e){
//     console.error(e)
//   }
// }


// export async function setUVId(externalUid){
//   const uvId = localStorage.getItem("uvId");
//   if(!uvId){
//     return;
//   }

//   try{
//     const res = await axiosInstance.post(API.BIND_UID,{uvId,externalUid})
//   }catch(e){
//     console.error(e)
//   }
// }

export const isJSONStr=(str)=> {
  if (typeof str == 'string') {
    try {
      var obj=JSON.parse(str);
      return true;
    } catch(e) {
      console.log('error：'+str+'!!!'+e);
      return false;
    }
  }
  return false;
}